module.exports = __webpack_public_path__ + "img/Group 7718.27e6a9cd.svg";